import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { DomainService } from './domain.service'
import { StorageService } from './storage.service'
import { ConfigService } from './config.service';
import { RequestService } from './request.service';


@Injectable()
export class LicenseService {
  getLogo(): string {
    return this.configService.get('aws').url + this.configService.get('routes').dolphinLogo;
  }

  constructor(
    private requestService: RequestService,
    private http: Http,
    private domainService: DomainService,
    private storageService: StorageService,
    private configService: ConfigService
  ) {
  }

  getLicenses(): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.license.list.api;
    return this.requestService.get(url);
  }

  getUpdatedLicenses(paginator?: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.license.updatedList.api;
    if (paginator) url += '?page=' + paginator.page + '&limit=' + paginator.limit + '&filter=' + paginator.filter;
    return this.requestService.get(url);
  }

  getClassAssignments(classId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.class.assignment.list.api + '/' + classId;
    return this.requestService.get(url);
  }

  getUpdatedClassAssignments(classId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.class.updatedAssignment.list.api + '/' + classId;
    return this.requestService.get(url);
  }


  getDeliverables(assignmentId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.content.list.api + '/' + assignmentId;
    return this.requestService.get(url);
  }

  getEvaluationDeliverables(assignmentId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.evaluation.list.api + '/' + assignmentId;
    return this.requestService.get(url);
  }

  getEvaluationDeliverablesNew(assignmentId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.evaluation.multiContent.api + '/' + assignmentId;
    return this.requestService.get(url);
  }

  getDeliverable(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.deliverable.read.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getContent(contentId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.content.read.api + '/' + contentId;
    return this.requestService.get(url);
  }

  checkStatus(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.deliverable.read.api + '/' + deliverableId;
    return Observable
      .timer(0, 5000)
      .flatMap(() => this.requestService.get(url, null, null, true))
      .map(response => response.data);
  }

  getScormManifest(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.scorm.imsmanifest.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getEBookFileUrl(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.ebook.fileurl.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getArchiveFileUrl(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.archive.fileurl.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getISpringFileUrl(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.ispring.fileurl.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getVideoUrl(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.video.fileurl.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getExternalContentFileUrl(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.externalContent.fileurl.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  validateRegistration(key: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').public.registration.vallidate.api + '/' + key;
    return this.requestService.get(url);
  }

  completeRegistration(key: string, data: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').public.registration.register.api + '/' + key;
    return this.requestService.post(url, data);
  }

  completeSelfRegistration(data: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').public.registration.selfregister.api;
    return this.requestService.post(url, data, true);
  }

  supportRequestPublic(data: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').public.support.create.api;
    return this.requestService.post(url, data);
  }

  supportRequestLearner(data: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.support.create.api;
    return this.requestService.post(url, data);
  }

  redeemVoucherRegistration(data: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').public.registration.redeemVoucher.api;
    return this.requestService.post(url, data, true);
  }

  redeemVoucher(voucher: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.license.redeem.api + '/' + voucher;
    return this.requestService.post(url, {});
  }

  redeemVoucherSuppressError(voucher: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.license.redeem.api + '/' + voucher;
    return this.requestService.post(url, {}, true);
  }

  remindPassword(model: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').public.password.remind.api;
    model.domain = this.domainService.getDomain().name;
    return this.requestService.post(url, model);
  }

  validatePasswordReset(key: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').public.password.reset.api + '/' + key;
    return this.requestService.get(url);
  }

  completePasswordReset(key: string, data: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').public.password.reset.api + '/' + key;
    return this.requestService.post(url, data);
  }

  setTrackingTotalPages(data: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.scorm.trackingPages.api;
    return this.requestService.post(url, data, true);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body;
  }

  private handleError(err: any) {
    err = err.json();
    let message = (err.error && err.error.message) ? err.error.message : 'Server error';
    console.log(message);
    return Observable.throw(message);
  }

  verifyContentChange(deliverableId: any) {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.content.verifyContent.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  verifyContentChangeBulk(deliverableId: any) {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.content.verifyContentBulk.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  updateContent(assignmentId: any, contents: any) {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.content.updateContent.api;
    return this.requestService.post(url, { assignmentId: assignmentId, updatedContents: contents });
  }

  getScormTracking(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.scorm.tracking.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  setScormTracking(deliverableId: string, data: any): Observable<any> {
    console.log('Setting tracking data');
    if (data.hasOwnProperty('organizations') && data.organizations.hasOwnProperty('CI_ORG')) {
      try {
        let percentage = 0;
        if (data != null && data.organizations) {
          let tracking = JSON.parse(data.organizations.CI_ORG.cmi.CI_SCO['cmi.suspend_data'].value);
          let slidesVisited = tracking && tracking.visitedslides ? tracking.visitedslides.data.length : 0;
          let totalSlides = data.totalPages ? data.totalPages : 0;

          if (slidesVisited <= totalSlides)
            percentage = Math.round((slidesVisited / totalSlides) * 100);
          else {
            let progress = data.organizations.CI_ORG.cmi.CI_SCO['cmi.progress_measure'];
            if (progress <= 1)
              percentage = progress * 100;
            else
              percentage = null;
          }
          data.percentage = percentage;
        }
      } catch (e) {
        if (!data.organizations.CI_ORG.cmi.hasOwnProperty('CI_SCO') && data.hasOwnProperty('totalPages') && data.totalPages == null) {
          data.percentage = 100;
          data.totalPages = 1;
        }
      }
    }

    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.scorm.tracking.api + '/' + deliverableId;
    return this.requestService.post(url, data, true);
  }

  public isRegistered(data: any, supressErrors?: boolean): Observable<any> {
    let url = this.configService.get('server').url + this.configService.get('endpoints').amber.isRegistered.api;
    return this.requestService.post(url, data, supressErrors);
  }

  getEvaluationScormManifest(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.evaluation.scorm.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getEvaluationEBookFileUrl(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.evaluation.ebook.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getEvaluationArchiveFileUrl(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.evaluation.archive.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getEvaluationISpringFileUrl(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.evaluation.ispring.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getEvaluationVideoUrl(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.evaluation.video.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getEvaluationPresentationUrl(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.evaluation.presentation.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  checkEvaluationStatus(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.evaluation.deliverableStatus.api + '/' + deliverableId;
    return Observable
      .timer(0, 5000)
      .flatMap(() => this.requestService.get(url))
      .map(response => response.data);
  }

  getExamResultsForVouchers(voucherNumbers: Array<string>): Observable<any> {
    const queryString = voucherNumbers.reduce((q, v) => q.concat(`voucherNumber=${v}&`), '');
    const url = this.configService.get('server').url + `/domain/api/voucher/v2/dasa/bulk/results?${queryString}`;
    return this.requestService.get(url);
  }

  listAssignmentsByMasterSku(sku: string): Observable<any> {
    const url = this.configService.get('server').url + `/domain/api/solar/learner/license/list/sku/${sku}`;
    return this.requestService.get(url, {}, 'json', true);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/license.service.ts